module.exports = __webpack_public_path__ + "img/aicj.444e25dc.png";